module.exports = (__webpack_require__(6))(450);


//////////////////
// WEBPACK FOOTER
// delegated ./node_modules/create-react-class/factory.js from dll-reference vendor_aa0bb54e7e791c5951ff
// module id = 326
// module chunks = 0 1 2